<section
  class="flex flex-col items-center pt-20 px-4 pb-14 mx-auto my-0 max-w-screen-lg"
>
  <app-section-header
    i18n-header
    i18n-description
    header="Explore our themes"
    description="For inventors, artists and gamers"
  />
  <div class="pb-12">
    <button class="button" i18n i18nRouterLink="/courses">
      Discover our full range!
    </button>
  </div>

  <div class="flex flex-col w-full items-center justify-center gap-4 mb-12">
    <div class="flex flex-wrap gap-4 justify-center">
      @for (category of categoryList(); track category) {
        <button
          mat-raised-button
          (click)="selectCategory(category)"
          [color]="category === selectedCategory() ? 'primary' : ''"
        >
          {{ category }}
        </button>
      }
    </div>
    @if (categoryList().length > 5) {
      <button
        mat-raised-button
        color="accent"
        (click)="expandCategories.set(!expandCategories())"
        class="mt-4"
      >
        <mat-icon>
          {{ expandCategories() ? "expand_less" : "expand_more" }}
        </mat-icon>
        <span i18n>
          {{ expandCategories() ? "Show less" : "Show more" }}
        </span>
      </button>
    }
  </div>

  <div
    class="grid grid-cols-1 p-4 md:p-0 md:grid-cols-2 lg:grid-cols-3 gap-4 items-stretch justify-center"
  >
    @for (course of courses.busy() ? [] : courses(); track course.id) {
      <app-course-catalogue-card
        class="flex h-full max-w-screen-sm"
        [course]="course"
        [link]="['/courses', course.id]"
      ></app-course-catalogue-card>
    } @empty {
      <app-category-card-skeleton></app-category-card-skeleton>
      <app-category-card-skeleton></app-category-card-skeleton>
      <app-category-card-skeleton></app-category-card-skeleton>
    }
  </div>
</section>
